import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ExternalSelectorModule } from '../external-selector/external-selector.module';
import { ProvinciaPickerComponent } from './provincia-picker/provincia-picker.component';
import { RegionePickerComponent } from './region-picker/region-picker.component';
import { UserPickerComponent } from './user-picker/user-picker.component';
import { StatoIncaricoPickerComponent } from './stato-incarico-picker/stato-incarico-picker.component';
import { StatoRiparazionePickerComponent } from './stato-riparazione-picker/stato-riparazione-picker.component';
import { StatoVideoperiziaPickerComponent } from './stato-videoperizia-picker/stato-videoperizia-picker.component';
import { CompagniaPickerComponent } from './compagnia-picker/compagnia-picker.component';
import { PolizzaPickerComponent } from './polizza-picker/polizza-picker.component';
import { IncaricoPickerComponent } from './incarico-picker/incarico-picker.component';
import { TipoDannoPickerComponent } from './tipo-danno-picker/tipo-danno-picker.component';
import { RamoPickerComponent } from './ramo-picker/ramo-picker.component';
import { AgenziaPickerComponent } from './agenzia-picker/agenzia-picker.component';
import { RiparatorePickerComponent } from './riparatore-picker/riparatore-picker.component';
import { FabbricatoPickerComponent } from './fabbricato-picker/fabbricato-picker.component';
import { AltroSoggettoPickerComponent } from './altro-soggetto-picker/altro-soggetto-picker.component';
import { IspettoratoPickerComponent } from './ispettorato-picker/ispettorato-picker.component';
import { StudioPickerComponent } from './studio-picker/studio-picker.component';
import { ComunePickerComponent } from './comune-picker/comune-picker.component';
import { GruppoPickerComponent } from './gruppo-picker/gruppo-picker.component';
import { ContraentePickerModule } from '../contraente-picker/contraente-picker.module';
import { TipoTemplatePickerComponent } from './tipo-template-picker/tipo-template-picker.component';
import { TipologiaCostruttivaPickerComponent } from './tipologia-costruttiva-picker/tipologia-costruttiva-picker.component';
import { ClasseFabbricatoPickerComponent } from './classe-fabbricato-picker/classe-fabbricato-picker.component';
import { StatoManutenzionePickerComponent } from './stato-manutenzione-picker/stato-manutenzione-picker.component';
import { LiquidatorePickerComponent } from './liquidatore-picker/liquidatore-picker.component';
import { TipoAltroSoggettoPickerComponent } from './tipo-altro-soggetto-picker/tipo-altro-soggetto-picker.component';
import { ContropartePickerComponent } from './controparte-picker/controparte-picker.component';
import { AmministratorePickerComponent } from './amministratore-picker/amministratore-picker.component';
import { ZonaGeograficaPickerComponent } from './zona-geografica-picker/zona-geografica-picker.component';
import { GruppoRamiPickerComponent } from './gruppo-rami-picker/gruppo-rami-picker.component';
import { GruppoTipiDannoPickerComponent } from './gruppo-tipi-danno-picker/gruppo-tipi-danno-picker.component';
import { CgaPickerComponent } from './cga-picker/cga-picker.component';
import { FilialePickerComponent } from './filiale-picker/filiale-picker.component';

const entityPickers = [
  ProvinciaPickerComponent,
  RegionePickerComponent,
  UserPickerComponent,
  StatoIncaricoPickerComponent,
  StatoRiparazionePickerComponent,
  StatoVideoperiziaPickerComponent,
  CompagniaPickerComponent,
  PolizzaPickerComponent,
  IncaricoPickerComponent,
  TipoDannoPickerComponent,
  AgenziaPickerComponent,
  RamoPickerComponent,
  IspettoratoPickerComponent,
  AltroSoggettoPickerComponent,
  FabbricatoPickerComponent,
  StudioPickerComponent,
  ComunePickerComponent,
  GruppoPickerComponent,
  TipoTemplatePickerComponent,
  TipologiaCostruttivaPickerComponent,
  ClasseFabbricatoPickerComponent,
  StatoManutenzionePickerComponent,
  RiparatorePickerComponent,
  LiquidatorePickerComponent,
  ContropartePickerComponent,
  TipoAltroSoggettoPickerComponent,
  AmministratorePickerComponent,
  ZonaGeograficaPickerComponent,
  GruppoRamiPickerComponent,
  GruppoTipiDannoPickerComponent,
  CgaPickerComponent,
  FilialePickerComponent,
]
@NgModule({
  declarations: entityPickers,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ExternalSelectorModule,
    ContraentePickerModule
  ],
  exports: entityPickers,
})
export class EntityPickersModule { }
